import { forwardRef, useState,useEffect, useImperativeHandle, } from "react";
import { useNavigate,useParams, useLocation } from "react-router-dom";
import { useQuery } from 'react-query';
import Axios from 'config/api';
import { setDocDetails } from 'redux/slices/inventorySlice';
import { useDispatch, useSelector } from "react-redux";
import Loader from "components/global/Loader";
import ItemNotFound from "components/global/ItemNotFound";
import DisplayError from "components/global/DisplayError";
import Status from "components/global/Status";
import Input from './inventoryinput/input';
import MultiSelect from './inventoryinput/MultiSelect';
import DatePicker from "./inventoryinput/DateInput";
import { Installment_TYPES, Installment_Options, Installment_Durtion,Monthly_Durtion, Yearly_Durtion, Quarterly_Balloon_Durtion, Monthly_Balloon_Durtion } from 'constants/app.constants';
import { PulseLoader } from "react-spinners";
import {create_purchasePlan}   from 'redux/actions/inventoryActions';

const InventoryPurchaseForm = forwardRef((props, ref) => {
  const [formData, setFormData] = useState({
    actualPrice: "",
    sellingPrice: "",
    category: '',
    fullPayment: "",
    downPayment: "",
    allocation: "",
    confirmation: "",
    possession: "",
    possessionDate: "",
    bookingDate:"",
    startOnBookingStream: "",

    // Quarterly
    quarterlyInstallment: "",
    quarterlyInstallmentsDuration: "",
    quarterlyDurationAmount: "",
    quarterlyStartDate: "",

    // Monthly
    monthlyInstallment: "",
    monthlyInstallmentsDuration: "",
    monthlyDurationAmount: "",
    monthlyStartDate: "",

    // Yearly
    yearlyInstallment: "",
    yearlyInstallmentDuration: "",
    yearlyDurationAmount: "",
    yearlyStartDate: "",
    monthlyBalloonInstallment: "",
    monthlyBalloonInstallmentDuration: "",
    monthlyBalloonDurationAmount: "",
    monthlyBalloonStartDate: "",
    quarterlyBalloonInstallment: "",
    quarterlyBalloonInstallmentDuration: "Quarterly + Balloon",
    quarterlyBalloonDurationAmount: "",
    quarterlyBalloonStartDate: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { docDetails } = useSelector(state => state.inventory);
  const { createLoading } = useSelector(state => state.purchasePlan);


  const location = useLocation();

const searchParams = new URLSearchParams(location.search);
  const inventory = searchParams.get("inventory");

  const [readOnly, setReadOnly] = useState(true);
  const [errors, setErrors] = useState({});

  const { data, isLoading, isError, error } = useQuery(
    ["single-inventory", inventory],
    () => Axios(`/inventory/${inventory}`)
  );

  useEffect(() => {
    if (!data?.data?.data?.doc) return;

    const d = data.data.data.doc;

    setFormData(prev => ({
      ...prev,
      actualPrice: d?.currentSale?.actualPrice || "",
      sellingPrice: d?.currentSale?.sellingPrice || "",
    }));

    dispatch(setDocDetails(d));
  }, [data, dispatch]);


  const saleId = docDetails?.currentSale?._id;
  // console.log('saleId',saleId)

  const inventoryId = docDetails?._id;




  useImperativeHandle(ref, () => ({
  submitForm: () => {
    handleSubmit();
  },
}));


const calculateInstallmentValues = (sellingPrice, category) => {
  const price = parseFloat(sellingPrice) || 0;
  if (price === 0) return {};

  const calculations = {};

 if (category === "3_year_installment") {
    calculations.downPayment = (price * 0.20).toFixed(2);
    calculations.possession = (price * 0.10).toFixed(2);

   
    calculations.monthlyInstallment = 30;
    const monthlyAmount = (price * 0.015).toFixed(2); 
    calculations.monthlyDurationAmount = `${monthlyAmount} (1.50%)`;
    calculations.monthlyInstallmentsDuration = "Monthly";

   
    calculations.yearlyInstallment = 5; 
    const yearlyAmount = (price * 0.05).toFixed(2);   
    calculations.yearlyDurationAmount = `${yearlyAmount} (5%)`;
    calculations.yearlyInstallmentDuration = "Half Yearly";
  }
  if (category === "new_3_year_installment") {
    calculations.downPayment = (price * 0.20).toFixed(2);
    calculations.monthlyInstallment = 36;
    calculations.monthlyDurationAmount = `${(price * 0.0152777777777778).toFixed(2)} (1.5277%)`;
    calculations.monthlyInstallmentsDuration = "Monthly";
    calculations.yearlyInstallment = 6;
    calculations.yearlyDurationAmount = `${(price * 0.0416666666666667).toFixed(2)} (4.1667%)`;
    calculations.yearlyInstallmentDuration = "Half Yearly";
  }

  if (category === "monthly_balloon_3year_installment") {
    calculations.downPayment = (price * 0.20).toFixed(2);
    calculations.monthlyInstallment = 30;
    calculations.monthlyDurationAmount = `${(price * 0.0152777777777778).toFixed(2)} (1.5277%)`;
    calculations.monthlyInstallmentsDuration = "Monthly";
    calculations.monthlyBalloonInstallment = 6;
    calculations.monthlyBalloonDurationAmount = `${(price * 0.0569444444444445).toFixed(2)} (5.6944%)`;
    calculations.monthlyBalloonInstallmentDuration = "Monthly + Half Yearly";
  }


if (category === "1_year_installment") {

 calculations.downPayment = (price * 0.25).toFixed(2);
  const remainingAfterInitial = price - (
    parseFloat(calculations.downPayment)   );

  calculations.quarterlyInstallment = 4;
  calculations.quarterlyInstallmentsDuration = "Quarterly";

  const quarterlyAmount = (remainingAfterInitial / 4).toFixed(2);
  const quarterlyPercent = ((remainingAfterInitial / 4 / price) * 100).toFixed(2);

  calculations.quarterlyDurationAmount = `${quarterlyAmount} (${quarterlyPercent}%)`;
}

  if (category === "residential_plan_1") {
    calculations.downPayment = (price * 0.20).toFixed(2);
    calculations.possession = (price * (0.10 + 0.0125)).toFixed(2); // 11.25%
    calculations.monthlyInstallment = 30;
    const monthlyAmount = (price * 0.0125).toFixed(2);
    calculations.monthlyDurationAmount = `${monthlyAmount} (1.25%)`;
    calculations.monthlyInstallmentsDuration = "Monthly";

    calculations.monthlyBalloonInstallment = 5;
    const balloonCombined = (price * (0.0125 + 0.05)).toFixed(2);
    calculations.monthlyBalloonDurationAmount = `${balloonCombined} (6.25%)`;
    calculations.monthlyBalloonInstallmentDuration = "Monthly + Half Yearly";
  }

  if (category === "residential_plan_2") {
    calculations.downPayment = (price * 0.20).toFixed(2);
    calculations.possession = "0.00";
    calculations.quarterlyInstallment = 12;
    const quarterlyAmount = (price * (0.80 / 12)).toFixed(2);
    calculations.quarterlyDurationAmount = `${quarterlyAmount} (6.67%)`;
    calculations.quarterlyInstallmentsDuration = "Quarterly";
  }

  if (category === "residential_plan_3") {
    calculations.downPayment = (price * 0.20).toFixed(2);
    calculations.possession = (price * 0.10).toFixed(2);
    calculations.quarterlyInstallment = 6;
    const quarterlyAmount = (price * 0.0375).toFixed(2);
    calculations.quarterlyDurationAmount = `${quarterlyAmount} (3.75%)`;
    calculations.quarterlyInstallmentsDuration = "Quarterly";

    calculations.quarterlyBalloonInstallment = 6;
    const quarterlyBalloonCombined = (price * (0.0375 + 0.0416666666666667)).toFixed(2);
    calculations.quarterlyBalloonDurationAmount = `${quarterlyBalloonCombined} (7.92%)`;
    calculations.quarterlyBalloonInstallmentDuration = "Quarterly + Balloon";
  }


  return calculations;
};

const handleToggleStartOnBooking = (streamKey) => {
  setFormData(prev => {
    const isCurrentlyActive = prev.startOnBookingStream === streamKey;
    const nextActive = isCurrentlyActive ? "" : streamKey;

    const updated = {
      ...prev,
      startOnBookingStream: nextActive,
    };

    if (nextActive && prev.bookingDate) {
      if (nextActive === "monthly") updated.monthlyStartDate = prev.bookingDate;
      if (nextActive === "quarterly") updated.quarterlyStartDate = prev.bookingDate;
      if (nextActive === "yearly") updated.yearlyStartDate = prev.bookingDate;
    }

    return updated;
  });
};

const handleChange = (field, value) => {
  setFormData(prev => {
    const updated = { ...prev, [field]: value };
    if (field === "bookingDate") {
      if (prev.startOnBookingStream === "monthly") updated.monthlyStartDate = value;
      if (prev.startOnBookingStream === "quarterly") updated.quarterlyStartDate = value;
      if (prev.startOnBookingStream === "yearly") updated.yearlyStartDate = value;
    }
    return updated;
  });

  if (errors[field]) {
    setErrors(prev => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });
  }


  if (field === "category") {
    if (value === "full_payment") {
      setFormData(prev => ({
        ...prev,

        actualPrice: prev.actualPrice,
        sellingPrice: prev.sellingPrice,
        category: value,

        fullPayment: "",
        downPayment: "",
        allocation: "",
        confirmation: "",
        possession: "",
        bookingDate:"",

        quarterlyInstallment: "",
        quarterlyInstallmentsDuration: "",
        quarterlyDurationAmount: "",
        quarterlyStartDate: "",

        monthlyInstallment: "",
        monthlyInstallmentsDuration: "",
        monthlyDurationAmount: "",
        monthlyStartDate: "",

        yearlyInstallment: "",
        yearlyInstallmentDuration: "",
        yearlyDurationAmount: "",
        yearlyStartDate: "",
      }));
    }

    if (value === "2_year_installment") {
      setFormData(prev => ({
        ...prev,
        actualPrice: prev.actualPrice,
        sellingPrice: prev.sellingPrice,
        category: value,

        // reset full-payment field
        fullPayment: "",

        // Installment fields cleared
        downPayment: "",
        allocation: "",
        confirmation: "",
        possession: "",
        bookingDate:"",
        quarterlyInstallment: "",
        quarterlyInstallmentsDuration: "",
        quarterlyDurationAmount: "",
        quarterlyStartDate: "",

        monthlyInstallment: "",
        monthlyInstallmentsDuration: "",
        monthlyDurationAmount: "",
        monthlyStartDate: "",

        yearlyInstallment: "",
        yearlyInstallmentDuration: "",
        yearlyDurationAmount: "",
        yearlyStartDate: "",
      }));
    }

    if (value === "3_year_installment") {
      setFormData(prev => ({
        ...prev,
        actualPrice: prev.actualPrice,
        sellingPrice: prev.sellingPrice,
        category: value,

        // reset full payment
        fullPayment: "",

        downPayment: "",
        allocation: "",
        confirmation: "",
        possession: "",
        bookingDate:"",
        quarterlyInstallment: "",
        quarterlyInstallmentsDuration: "",
        quarterlyDurationAmount: "",
        quarterlyStartDate: "",

        monthlyInstallment: "",
        monthlyInstallmentsDuration: "",
        monthlyDurationAmount: "",
        monthlyStartDate: "",

        yearlyInstallment: "",
        yearlyInstallmentDuration: "",
        yearlyDurationAmount: "",
        yearlyStartDate: "",
      }));
    }
    if (value === "new_3_year_installment" || value === "monthly_balloon_3year_installment") {
      setFormData(prev => ({
        ...prev,
        category: value,
        fullPayment: "",
        downPayment: "",
        allocation: "",
        confirmation: "",
        possession: "",
        quarterlyInstallment: "",
        quarterlyInstallmentsDuration: "",
        quarterlyDurationAmount: "",
        quarterlyStartDate: "",
        monthlyInstallment: "",
        monthlyInstallmentsDuration: "",
        monthlyDurationAmount: "",
        monthlyStartDate: "",
        yearlyInstallment: "",
        yearlyInstallmentDuration: "",
        yearlyDurationAmount: "",
        yearlyStartDate: "",
        monthlyBalloonInstallment: "",
        monthlyBalloonInstallmentDuration: "",
        monthlyBalloonDurationAmount: "",
        monthlyBalloonStartDate: "",
      }));
    }

    if (["residential_plan_1", "residential_plan_2", "residential_plan_3"].includes(value)) {
      setFormData(prev => ({
        ...prev,
        actualPrice: prev.actualPrice,
        sellingPrice: prev.sellingPrice,
        category: value,

        fullPayment: "",
        downPayment: "",
        allocation: "",
        confirmation: "",
        possession: "",
        possessionDate: "",
        startOnBookingStream: "",

        quarterlyInstallment: "",
        quarterlyInstallmentsDuration: "",
        quarterlyDurationAmount: "",
        quarterlyStartDate: "",

        monthlyInstallment: "",
        monthlyInstallmentsDuration: "",
        monthlyDurationAmount: "",
        monthlyStartDate: "",

        yearlyInstallment: "",
        yearlyInstallmentDuration: "",
        yearlyDurationAmount: "",
        yearlyStartDate: "",

        monthlyBalloonInstallment: "",
        monthlyBalloonInstallmentDuration: "",
        monthlyBalloonDurationAmount: "",
        monthlyBalloonStartDate: "",

        quarterlyBalloonInstallment: "",
        quarterlyBalloonInstallmentDuration: "Quarterly + Balloon",
        quarterlyBalloonDurationAmount: "",
        quarterlyBalloonStartDate: "",
      }));
    }
  }

  // Auto calculate for predefined plans
  if ((field === "sellingPrice" || field === "category") && value) {
    const sellingPrice = field === "sellingPrice" ? value : formData.sellingPrice;
    const category = field === "category" ? value : formData.category;

    if (
      sellingPrice &&
      [
        "3_year_installment",
        "new_3_year_installment",
        "monthly_balloon_3year_installment",
        "1_year_installment",
        "residential_plan_1",
        "residential_plan_2",
        "residential_plan_3",
      ].includes(category)
    ) {
      const calculated = calculateInstallmentValues(sellingPrice, category);
      setFormData(prev => ({
        ...prev,
        ...calculated,
      }));
    }
  }
};


const validateForm = () => {
  const newErrors = {};

  const isFullPayment = formData.category === "full_payment";
  const isInstallment = formData.category === "2_year_installment";
  const isPlan2 = formData.category === "residential_plan_2";
  const isResidential = [
    "3_year_installment",
    "new_3_year_installment",
    "monthly_balloon_3year_installment",
    "residential_plan_1",
    "residential_plan_2",
    "residential_plan_3"
  ].includes(formData.category);


  const isPositive = (value) =>
    value !== "" && !isNaN(value) && Number(value) > 0;

  if (!formData.category) {
    newErrors.category = "Category is required";
  }

  if (isFullPayment) {
    if (formData.fullPayment !== "" && !isPositive(formData.fullPayment)) {
      newErrors.fullPayment = "Full payment must be greater than 0";
    }
  }

  if (isInstallment || isResidential) {
    if (formData.downPayment !== "" && !isPositive(formData.downPayment)) {
      newErrors.downPayment = "Down Payment must be greater than 0";
    }

    if (formData.allocation !== "" && !isPositive(formData.allocation)) {
      newErrors.allocation = "Allocation must be greater than 0";
    }

    if (formData.confirmation !== "" && !isPositive(formData.confirmation)) {
      newErrors.confirmation = "Confirmation must be greater than 0";
    }

    if (!isPlan2 && formData.possession !== "" && !isPositive(formData.possession)) {
      newErrors.possession = "Possession must be greater than 0";
    }
  }



  const validateGroup = ({
    type,
    duration,
    amount,
    startDate,
    groupName
  }) => {
    const isAnyFilled =
      type !== "" || duration !== "" || amount !== "" || startDate !== "";

    if (!isAnyFilled) return; 


    if (type === "") {
      newErrors[groupName + "Installment"] = "Installment type is required";
    }

    if (duration === "") {
      newErrors[groupName + "InstallmentsDuration"] =
        "Duration is required";
    }

    if (amount === "" || !isPositive(amount)) {
      newErrors[groupName + "DurationAmount"] =
        "Amount must be greater than 0";
    }

  };

  if (isInstallment) {
    validateGroup({
      type: formData.quarterlyInstallment,
      duration: formData.quarterlyInstallmentsDuration,
      amount: formData.quarterlyDurationAmount,
      startDate: formData.quarterlyStartDate,
      groupName: "quarterly"
    });

    validateGroup({
      type: formData.monthlyInstallment,
      duration: formData.monthlyInstallmentsDuration,
      amount: formData.monthlyDurationAmount,
      startDate: formData.monthlyStartDate,
      groupName: "monthly"
    });

    validateGroup({
      type: formData.yearlyInstallment,
      duration: formData.yearlyInstallmentDuration,
      amount: formData.yearlyDurationAmount,
      startDate: formData.yearlyStartDate,
      groupName: "yearly"
    });
  }


  if (isInstallment && formData.quarterlyBalloonInstallment) {
    if (!formData.quarterlyBalloonInstallmentDuration) newErrors.quarterlyBalloonInstallmentDuration = "Duration is required";
    if (!Number(String(formData.quarterlyBalloonDurationAmount).replace(/[^0-9.]/g, ""))) newErrors.quarterlyBalloonDurationAmount = "Amount is required";
  }


  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};




const handleSubmit = async () => {
  if (!validateForm()) return;

  const isFullPayment = formData.category === "full_payment";
const extractAmount = (value) => {
  if (value === undefined || value === null || value === "") return undefined;
  return String(value).split(" ")[0].replace(/,/g, "");
};


 const formatDate = (date) => {
    const d = new Date(date);
    const pad = (n) => n.toString().padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  };


  const isResidential = [
    "3_year_installment",
    "new_3_year_installment",
    "monthly_balloon_3year_installment",
    "residential_plan_1",
    "residential_plan_2",
    "residential_plan_3",
  ].includes(formData.category);
  const isInstallment = ["2_year_installment"].includes(formData.category);
  const isCommerical = ["1_year_installment"].includes(formData.category);


  // Base payload
  let payload = {
    category: formData.category,
    sale: saleId,
    inventory: inventoryId,
  };

  if (isFullPayment) {
    payload = {
      ...payload,
      ...(formData.fullPayment && { fullPayment: formData.fullPayment }),
            ...(formData.bookingDate && { bookingDate: formatDate(formData.bookingDate) }),

    };
  }

  if (isInstallment) {
    payload = {
      ...payload,
        ...(formData.downPayment && { downPayment: Number(formData.downPayment) }),
  ...(formData.allocation && { allocation: Number(formData.allocation) }),
  ...(formData.confirmation && { confirmation: Number(formData.confirmation) }),
  ...(formData.possession && { possession: Number(formData.possession) }),
  ...(formData.possessionDate && { possessionDate: formatDate(formData.possessionDate) }),
        ...(formData.bookingDate && { bookingDate: formatDate(formData.bookingDate) }),

      // Optional installment schedules
      ...(formData.quarterlyInstallment && {
        quarterly: {
          count: formData.quarterlyInstallment,
          duration: formData.quarterlyInstallmentsDuration,
          amount: Number(formData.quarterlyDurationAmount),
         ...( formData.quarterlyStartDate && { startDate: formatDate(formData.quarterlyStartDate)}),
         startOnBookingDate: formData.startOnBookingStream === "quarterly",

        },
      }),

      ...(formData.monthlyInstallment && {
        monthly: {
          count: formData.monthlyInstallment,
          duration: formData.monthlyInstallmentsDuration,
          amount: Number(formData.monthlyDurationAmount),
        ...( formData.monthlyStartDate && { startDate: formatDate(formData.monthlyStartDate)}),
        startOnBookingDate: formData.startOnBookingStream === "monthly",
        },
      }),

      ...(formData.yearlyInstallment && {
        balloon: {
          count: formData.yearlyInstallment,
          duration: formData.yearlyInstallmentDuration,
          amount: Number(formData.yearlyDurationAmount),
            ...( formData.yearlyStartDate && {startDate: formatDate(formData.yearlyStartDate)}),
            startOnBookingDate: formData.startOnBookingStream === "yearly",
        },
      }),
    };
  }


if (isResidential) {
  payload = {
    ...payload,
    ...(formData.downPayment && { downPayment: Number(formData.downPayment) }),
    ...(formData.allocation && { allocation: Number(formData.allocation) }),
    ...(formData.confirmation && { confirmation: Number(formData.confirmation) }),
    ...(Number(formData.possession) > 0 && { possession: Number(formData.possession) }),
    ...(formData.possessionDate && { possessionDate: formatDate(formData.possessionDate) }),
    ...(formData.bookingDate && { bookingDate: formatDate(formData.bookingDate) }),

    // Monthly installment
    ...(formData.monthlyInstallment && {
      monthly: {
        count: formData.monthlyInstallment,
        duration: formData.monthlyInstallmentsDuration,
        amount: Number(extractAmount(formData.monthlyDurationAmount)),
        ...(formData.monthlyStartDate && { startDate: formatDate(formData.monthlyStartDate) }),
        startOnBookingDate: formData.startOnBookingStream === "monthly",
      },
    }),

    // Yearly installment
    ...(formData.yearlyInstallment && {
      balloon: {
        count: formData.yearlyInstallment,
        duration: formData.yearlyInstallmentDuration,
        amount: Number(extractAmount(formData.yearlyDurationAmount)),
        ...(formData.yearlyStartDate && { startDate: formatDate(formData.yearlyStartDate) }),
        startOnBookingDate: formData.startOnBookingStream === "yearly",
      },
    }),

    // monthly & Balloon installment
    ...(formData.monthlyBalloonInstallment && {
      monthlyBalloon: {
        count: formData.monthlyBalloonInstallment,
        duration: formData.monthlyBalloonInstallmentDuration,
        amount: Number(extractAmount(formData.monthlyBalloonDurationAmount)),
        ...(formData.monthlyBalloonStartDate && { startDate: formatDate(formData.monthlyBalloonStartDate) }),
      },
    }),

    // Quarterly installment
    ...(formData.quarterlyInstallment && {
      quarterly: {
        count: formData.quarterlyInstallment,
        duration: formData.quarterlyInstallmentsDuration,
        amount: Number(extractAmount(formData.quarterlyDurationAmount)),
        ...(formData.quarterlyStartDate && { startDate: formatDate(formData.quarterlyStartDate) }),
        startOnBookingDate: formData.startOnBookingStream === "quarterly",
      },
    }),

    // Quarterly Balloon installment
    ...(formData.quarterlyBalloonInstallment && {
      quarterlyBalloon: {
        count: formData.quarterlyBalloonInstallment,
        duration: formData.quarterlyBalloonInstallmentDuration,
        amount: Number(extractAmount(formData.quarterlyBalloonDurationAmount)),
        ...(formData.quarterlyBalloonStartDate && { startDate: formatDate(formData.quarterlyBalloonStartDate) }),
      },
    }),
  };
}



 if (isCommerical) {
    payload = {
      ...payload,
        ...(formData.downPayment && { downPayment: Number(formData.downPayment) }),
  ...(formData.allocation && { allocation: Number(formData.allocation) }),
  ...(formData.confirmation && { confirmation: Number(formData.confirmation) }),
  ...(formData.possession && { possession: Number(formData.possession) }),
  ...(formData.possessionDate && { possessionDate: formatDate(formData.possessionDate) }),
        ...(formData.bookingDate && { bookingDate: formatDate(formData.bookingDate) }),

      // Optional installment schedules
      ...(formData.quarterlyInstallment && {
        quarterly: {
          count: formData.quarterlyInstallment,
          duration: formData.quarterlyInstallmentsDuration,
                  amount: Number(extractAmount(formData.quarterlyDurationAmount)), 
                 ...( formData.quarterlyStartDate && { startDate: formatDate(formData.quarterlyStartDate)}),


        },
      }),

    
    };
  }



  console.log("FINAL PAYLOAD:", payload);



  if (isInstallment && formData.monthlyBalloonInstallment) {
    payload.monthlyBalloon = {
      count: formData.monthlyBalloonInstallment,
      duration: formData.monthlyBalloonInstallmentDuration,
      amount: Number(extractAmount(formData.monthlyBalloonDurationAmount)),
      ...(formData.monthlyBalloonStartDate && { startDate: formatDate(formData.monthlyBalloonStartDate) }),
    };
  }

  if (isInstallment && formData.quarterlyBalloonInstallment) {
    payload.quarterlyBalloon = {
      count: formData.quarterlyBalloonInstallment,
      duration: formData.quarterlyBalloonInstallmentDuration,
      amount: Number(extractAmount(formData.quarterlyBalloonDurationAmount)),
      ...(formData.quarterlyBalloonStartDate && { startDate: formatDate(formData.quarterlyBalloonStartDate) }),
    };
  }


   try {
    await dispatch(create_purchasePlan(payload,navigate));

      setFormData({
      actualPrice: docDetails?.currentSale?.actualPrice,
        sellingPrice:  docDetails?.currentSale?.sellingPrice ,
    category: '',
    fullPayment: "",
    downPayment: "",
    allocation: "",
    confirmation: "",
    possession: "",
    bookingDate:"",
    quarterlyInstallment: "",
    quarterlyInstallmentsDuration: "",
    quarterlyDurationAmount: "",
    quarterlyStartDate: "",

    monthlyInstallment: "",
    monthlyInstallmentsDuration: "",
    monthlyDurationAmount: "",
    monthlyStartDate: "",

    yearlyInstallment: "",
    yearlyInstallmentDuration: "",
    yearlyDurationAmount: "",
    yearlyStartDate: "",
    });
    setErrors({}); 
  
 
  } catch (error) {
    console.error("Error submitting client:", error);
    
  }
  // dispatch(createPurchasePlan(payload))
};







const selectedCategory = String(formData.category || "").trim();
const isFullPayment = selectedCategory === "full_payment";
const isInstallment = selectedCategory === "2_year_installment";
const isPlan1 = selectedCategory === "residential_plan_1";
const isPlan2 = selectedCategory === "residential_plan_2";
const isPlan3 = selectedCategory === "residential_plan_3";
const isResidential = [
  "3_year_installment",
  "new_3_year_installment",
  "monthly_balloon_3year_installment",
  "residential_plan_1",
  "residential_plan_2",
  "residential_plan_3",
].includes(selectedCategory);
const isCommerical = selectedCategory === "1_year_installment";


  if (isLoading) return <Loader />;
  if (isError) return <DisplayError message={error?.message || "Something went wrong"} />;
  if (!docDetails) return <ItemNotFound message="Inventory not found" />;

  return (
    <div className="flex flex-col gap-6">
      {/* HEADER */}
      <div className="flex items-center gap-4 px-3 pt-4">
        <div>
          <h2 className="text-xl font-semibold capitalize">
            {docDetails?.project?.title} - {docDetails?.sector?.title}
          </h2>
          <p className="text-sm pt-3"><Status status={docDetails?.status} /></p>
        </div>
      </div>

      {/* BASIC PRICING */}
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-5 px-3">
        <Input
          label="Actual Price"
          name="actualPrice"
          type="text"
          readOnly={readOnly}
          value={formData.actualPrice}
          onChange={(e) => handleChange("actualPrice", e.target.value)}
          error={errors.actualPrice}
        />
        <Input
          label="Selling Price"
          name="sellingPrice"
          type="text"
          readOnly={readOnly}
          value={formData.sellingPrice}
          onChange={(e) => handleChange("sellingPrice", e.target.value)}
          error={errors.sellingPrice}
        />

        <MultiSelect
          label="Category"
          name="category"
          value={formData.category}
          onChange={(val) => handleChange("category", val)}
          error={errors.category}
          options={Installment_TYPES}
        />
  <DatePicker
                  label="Booking Date"
                  name="bookingDate"
                  value={formData.bookingDate}
                  onChange={(val) => handleChange("bookingDate", val)}
                  error={errors.bookingDate}
                />
{isFullPayment && (
  <Input
    label="Full Payment"
    name="fullPayment"
    type="number"
    value={formData.fullPayment}
    onChange={(e) => handleChange("fullPayment", e.target.value)}
    error={errors.fullPayment}
  />
)}

{isInstallment && (

  <>

        <Input
          label="Down Payment"
          name="downPayment"
          type="number"
          value={formData.downPayment}
          onChange={(e) => handleChange("downPayment", e.target.value)}
          error={errors.downPayment}
        />
        <Input
          label="Allocation"
          name="allocation"
          type="text"
          value={formData.allocation}
          onChange={(e) => handleChange("allocation", e.target.value)}
          error={errors.allocation}
        />
        <Input
          label="Confirmation"
          name="confirmation"
          type="text"
          value={formData.confirmation}
          onChange={(e) => handleChange("confirmation", e.target.value)}
          error={errors.confirmation}
        />
        <Input
          label="Possession"
          name="possession"
          type="text"
          value={formData.possession}
          onChange={(e) => handleChange("possession", e.target.value)}
          error={errors.possession}
        />
        <DatePicker
          label="Possession Date (Optional)"
          name="possessionDate"
          value={formData.possessionDate}
          onChange={(val) => handleChange("possessionDate", val)}
          error={errors.possessionDate}
        />
</>)}

   {(isResidential) && (
          <>
            <Input
              label="Down Payment (20%)"
              name="downPayment"
              type="number"
              value={formData.downPayment}
              onChange={(e) => handleChange("downPayment", e.target.value)}
              error={errors.downPayment}
            />
            <Input
              label="Allocation"
              name="allocation"
              type="number"
              value={formData.allocation}
              onChange={(e) => handleChange("allocation", e.target.value)}
              error={errors.allocation}
            />
            <Input
              label="Confirmation"
              name="confirmation"
              type="number"
              value={formData.confirmation}
              onChange={(e) => handleChange("confirmation", e.target.value)}
              error={errors.confirmation}
            />
            {!isPlan2 && (
              <>
                <Input
                  label={isPlan1 ? "Possession (11.25%)" : "Possession (10%)"}
                  name="possession"
                  type="number"
                  value={formData.possession}
                  onChange={(e) => handleChange("possession", e.target.value)}
                  error={errors.possession}
                />
                <DatePicker
                  label="Possession Date (Optional)"
                  name="possessionDate"
                  value={formData.possessionDate}
                  onChange={(val) => handleChange("possessionDate", val)}
                  error={errors.possessionDate}
                />
              </>
            )}
          </>
        )}





          {(isCommerical) && (
          <>
            <Input
              label="Down Payment (25%)"
              name="downPayment"
              type="number"
              value={formData.downPayment}
              onChange={(e) => handleChange("downPayment", e.target.value)}
              error={errors.downPayment}
            />
            <Input
              label="Allocation"
              name="allocation"
              type="number"
              value={formData.allocation}
              onChange={(e) => handleChange("allocation", e.target.value)}
              error={errors.allocation}
            />
            <Input
              label="Confirmation"
              name="confirmation"
              type="number"
              value={formData.confirmation}
              onChange={(e) => handleChange("confirmation", e.target.value)}
              error={errors.confirmation}
            />
            <Input
              label="Possession"
              name="possession"
              type="number"
              value={formData.possession}
              onChange={(e) => handleChange("possession", e.target.value)}
              error={errors.possession}
            />
            <DatePicker
              label="Possession Date (Optional)"
              name="possessionDate"
              value={formData.possessionDate}
              onChange={(val) => handleChange("possessionDate", val)}
              error={errors.possessionDate}
            />
          </>
        )}
        
      </div>




    {(isCommerical || isPlan2 || isPlan3) && (
        <>

            <h3 className="text-lg font-semibold mb-4 px-2">Quarterly Installments</h3>
            {(isPlan2 || isPlan3) && (
              <div className="flex items-center gap-3 px-3 py-1 mb-2">
                <button
                  type="button"
                  role="switch"
                  aria-checked={formData.startOnBookingStream === "quarterly"}
                  onClick={() => handleToggleStartOnBooking("quarterly")}
                  className={`relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
                    formData.startOnBookingStream === "quarterly" ? "bg-primary" : "bg-gray-300"
                  }`}
                >
                  <span
                    className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                      formData.startOnBookingStream === "quarterly" ? "translate-x-4" : "translate-x-0"
                    }`}
                  />
                </button>
                <span
                  className="text-xs sm:text-sm font-medium text-gray-700 cursor-pointer select-none"
                  onClick={() => handleToggleStartOnBooking("quarterly")}
                >
                  Start 1st installment on booking / down payment date
                </span>
                {formData.startOnBookingStream === "quarterly" && (
                  <span className="text-xs bg-emerald-50 text-emerald-600 border border-emerald-200 font-semibold px-2 py-0.5 rounded-full">
                    Active
                  </span>
                )}
              </div>
            )}
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 px-3 border-b pb-6">
              <Input
                label="Quarterly Installment Count"
                name="quarterlyInstallment"
                value={formData.quarterlyInstallment}
                onChange={(e) => handleChange("quarterlyInstallment", e.target.value)}
                error={errors.quarterlyInstallment}

              />

              <MultiSelect
                label="Quarterly Duration"
                name="quarterlyInstallmentsDuration"
                value={formData.quarterlyInstallmentsDuration}
                onChange={(val) => handleChange("quarterlyInstallmentsDuration", val)}
                error={errors.quarterlyInstallmentsDuration}
                options={Installment_Durtion}
              />

              <Input
                  label="Quarterly Installment"
                  name="quarterlyDurationAmount"
                  type="text"
                  value={formData.quarterlyDurationAmount}
                  onChange={(e) => handleChange("quarterlyDurationAmount", e.target.value)}
                  error={errors.quarterlyDurationAmount}
                />

              <DatePicker
                label="Quarterly Start Date"
                name="quarterlyStartDate"
                value={formData.quarterlyStartDate}
                onChange={(val) => handleChange("quarterlyStartDate", val)}
                error={errors.quarterlyStartDate}
              />
            </div>





        </>
      )}


    {isResidential && !isPlan2 && !isPlan3 && (
        <>

            <h3 className="text-lg font-semibold mb-0.5 px-2">Monthly Installments</h3>
            {isPlan1 && (
              <div className="flex items-center gap-3 px-3 py-1 mb-2">
                <button
                  type="button"
                  role="switch"
                  aria-checked={formData.startOnBookingStream === "monthly"}
                  onClick={() => handleToggleStartOnBooking("monthly")}
                  className={`relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
                    formData.startOnBookingStream === "monthly" ? "bg-primary" : "bg-gray-300"
                  }`}
                >
                  <span
                    className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                      formData.startOnBookingStream === "monthly" ? "translate-x-4" : "translate-x-0"
                    }`}
                  />
                </button>
                <span
                  className="text-xs sm:text-sm font-medium text-gray-700 cursor-pointer select-none"
                  onClick={() => handleToggleStartOnBooking("monthly")}
                >
                  Start 1st installment on booking / down payment date
                </span>
                {formData.startOnBookingStream === "monthly" && (
                  <span className="text-xs bg-emerald-50 text-emerald-600 border border-emerald-200 font-semibold px-2 py-0.5 rounded-full">
                    Active
                  </span>
                )}
              </div>
            )}
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 px-3 border-b pb-6">
              <Input
                label="Monthly Installment Count"
                name="monthlyInstallment"
                value={formData.monthlyInstallment}
                onChange={(e) => handleChange("monthlyInstallment", e.target.value)}
                error={errors.monthlyInstallment}

              />

              <MultiSelect
                label="Monthly Duration"
                name="monthlyInstallmentsDuration"
                value={formData.monthlyInstallmentsDuration}
                onChange={(val) => handleChange("monthlyInstallmentsDuration", val)}
                error={errors.monthlyInstallmentsDuration}
                options={Monthly_Durtion}
              />

              <Input
                label="Monthly Installment Amount"
                name="monthlyDurationAmount"
                type="text"
                value={formData.monthlyDurationAmount}
                onChange={(e) => handleChange("monthlyDurationAmount", e.target.value)}
                error={errors.monthlyDurationAmount}
              />

              <DatePicker
                label="Monthly Start Date"
                name="monthlyStartDate"
                value={formData.monthlyStartDate}
                onChange={(val) => handleChange("monthlyStartDate", val)}
                error={errors.monthlyStartDate}
              />
            </div>



            {!["monthly_balloon_3year_installment", "residential_plan_1", "residential_plan_2", "residential_plan_3"].includes(selectedCategory) && <>
            <h3 className="text-lg font-semibold mb-4 px-2">Biannual Installments</h3>
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 px-3">
              <Input
                label="Biannual Installments Count"
                name="yearlyInstallment"
                value={formData.yearlyInstallment}
                onChange={(e) => handleChange("yearlyInstallment", e.target.value)}
                error={errors.yearlyInstallment}

              />

              <MultiSelect
                label="Biannual Duration"
                name="yearlyInstallmentDuration"
                value={formData.yearlyInstallmentDuration}
                onChange={(val) => handleChange("yearlyInstallmentDuration", val)}
                error={errors.yearlyInstallmentDuration}
                options={Yearly_Durtion}
              />

              <Input
                label="Biannual Installment Amount"
                name="yearlyDurationAmount"
                type="text"
                value={formData.yearlyDurationAmount}
                onChange={(e) => handleChange("yearlyDurationAmount", e.target.value)}
                error={errors.yearlyDurationAmount}
              />

              <DatePicker
                label="Biannual Start Date"
                name="yearlyStartDate"
                value={formData.yearlyStartDate}
                onChange={(val) => handleChange("yearlyStartDate", val)}
                error={errors.yearlyStartDate}
              />
            </div>
            </>}

            {["monthly_balloon_3year_installment", "residential_plan_1"].includes(selectedCategory) && <>
              <h3 className="text-lg font-semibold mb-4 px-2">Monthly &amp; Balloon Installments</h3>
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 px-3">
                <Input
                  label="Monthly & Balloon Installments Count"
                  name="monthlyBalloonInstallment"
                  value={formData.monthlyBalloonInstallment}
                  onChange={(e) => handleChange("monthlyBalloonInstallment", e.target.value)}
                  error={errors.monthlyBalloonInstallment}
                />

                <MultiSelect
                  label="Monthly & Balloon Duration"
                  name="monthlyBalloonInstallmentDuration"
                  value={formData.monthlyBalloonInstallmentDuration}
                  onChange={(val) => handleChange("monthlyBalloonInstallmentDuration", val)}
                  error={errors.monthlyBalloonInstallmentDuration}
                  options={Monthly_Balloon_Durtion}
                />

                <Input
                  label="Monthly & Balloon Installment Amount"
                  name="monthlyBalloonDurationAmount"
                  type="text"
                  value={formData.monthlyBalloonDurationAmount}
                  onChange={(e) => handleChange("monthlyBalloonDurationAmount", e.target.value)}
                  error={errors.monthlyBalloonDurationAmount}
                />

                <DatePicker
                  label="Monthly & Balloon Start Date"
                  name="monthlyBalloonStartDate"
                  value={formData.monthlyBalloonStartDate}
                  onChange={(val) => handleChange("monthlyBalloonStartDate", val)}
                  error={errors.monthlyBalloonStartDate}
                />
              </div>
            </>}

        </>
      )}

      {isPlan3 && (
        <>
          <h3 className="text-lg font-semibold mb-4 px-2">Quarterly + Balloon Installments</h3>
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 px-3">
            <Input
              label="Quarterly + Balloon Installments Count"
              name="quarterlyBalloonInstallment"
              value={formData.quarterlyBalloonInstallment}
              onChange={(e) => handleChange("quarterlyBalloonInstallment", e.target.value)}
              error={errors.quarterlyBalloonInstallment}
            />
            <MultiSelect
              label="Quarterly + Balloon Duration"
              name="quarterlyBalloonInstallmentDuration"
              value={formData.quarterlyBalloonInstallmentDuration}
              onChange={(val) => handleChange("quarterlyBalloonInstallmentDuration", val)}
              error={errors.quarterlyBalloonInstallmentDuration}
              options={Quarterly_Balloon_Durtion}
            />
            <Input
              label="Quarterly + Balloon Installment Amount"
              name="quarterlyBalloonDurationAmount"
              type="text"
              value={formData.quarterlyBalloonDurationAmount}
              onChange={(e) => handleChange("quarterlyBalloonDurationAmount", e.target.value)}
              error={errors.quarterlyBalloonDurationAmount}
            />
            <DatePicker
              label="Quarterly + Balloon Start Date"
              name="quarterlyBalloonStartDate"
              value={formData.quarterlyBalloonStartDate}
              onChange={(val) => handleChange("quarterlyBalloonStartDate", val)}
              error={errors.quarterlyBalloonStartDate}
            />
          </div>
        </>
      )}

{isInstallment && (
     <>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3 px-3 py-1">
          <button
            type="button"
            role="switch"
            aria-checked={formData.startOnBookingStream === "quarterly"}
            onClick={() => handleToggleStartOnBooking("quarterly")}
            className={`relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
              formData.startOnBookingStream === "quarterly" ? "bg-primary" : "bg-gray-300"
            }`}
          >
            <span
              className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                formData.startOnBookingStream === "quarterly" ? "translate-x-4" : "translate-x-0"
              }`}
            />
          </button>
          <span
            className="text-xs sm:text-sm font-medium text-gray-700 cursor-pointer select-none"
            onClick={() => handleToggleStartOnBooking("quarterly")}
          >
            Start 1st installment on booking / down payment date
          </span>
          {formData.startOnBookingStream === "quarterly" && (
            <span className="text-xs bg-emerald-50 text-emerald-600 border border-emerald-200 font-semibold px-2 py-0.5 rounded-full">
              Active
            </span>
          )}
        </div>
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 px-3 ">
          <MultiSelect
            label="Quarterly Installment Type"
            name="quarterlyInstallment"
            value={formData.quarterlyInstallment}
            onChange={(val) => handleChange("quarterlyInstallment", val)}
            error={errors.quarterlyInstallment}
            options={Installment_Options}
          />

          <MultiSelect
            label="Quarterly Duration"
            name="quarterlyInstallmentsDuration"
            value={formData.quarterlyInstallmentsDuration}
            onChange={(val) => handleChange("quarterlyInstallmentsDuration", val)}
            error={errors.quarterlyInstallmentsDuration}
            options={Installment_Durtion}
          />

          <Input
            label="Quarterly Duration Amount"
            name="quarterlyDurationAmount"
            type="text"
            value={formData.quarterlyDurationAmount}
            onChange={(e) => handleChange("quarterlyDurationAmount", e.target.value)}
            error={errors.quarterlyDurationAmount}
          />

          <DatePicker
            label="Quarterly Start Date"
            name="quarterlyStartDate"
            value={formData.quarterlyStartDate}
            onChange={(val) => handleChange("quarterlyStartDate", val)}
            error={errors.quarterlyStartDate}
          />
        </div>
      </div>
      </>
)}

   {isInstallment && (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3 px-3 py-1">
          <button
            type="button"
            role="switch"
            aria-checked={formData.startOnBookingStream === "monthly"}
            onClick={() => handleToggleStartOnBooking("monthly")}
            className={`relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
              formData.startOnBookingStream === "monthly" ? "bg-primary" : "bg-gray-300"
            }`}
          >
            <span
              className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                formData.startOnBookingStream === "monthly" ? "translate-x-4" : "translate-x-0"
              }`}
            />
          </button>
          <span
            className="text-xs sm:text-sm font-medium text-gray-700 cursor-pointer select-none"
            onClick={() => handleToggleStartOnBooking("monthly")}
          >
            Start 1st installment on booking / down payment date
          </span>
          {formData.startOnBookingStream === "monthly" && (
            <span className="text-xs bg-emerald-50 text-emerald-600 border border-emerald-200 font-semibold px-2 py-0.5 rounded-full">
              Active
            </span>
          )}
        </div>
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 px-3 border-b ">
          <MultiSelect
            label="Monthly Installment Type"
            name="monthlyInstallment"
            value={formData.monthlyInstallment}
            onChange={(val) => handleChange("monthlyInstallment", val)}
            error={errors.monthlyInstallment}
            options={Installment_Options}
          />

          <MultiSelect
            label="Monthly Duration"
            name="monthlyInstallmentsDuration"
            value={formData.monthlyInstallmentsDuration}
            onChange={(val) => handleChange("monthlyInstallmentsDuration", val)}
            error={errors.monthlyInstallmentsDuration}
            options={Monthly_Durtion}
          />

          <Input
            label="Monthly Duration Amount"
            name="monthlyDurationAmount"
            type="text"
            value={formData.monthlyDurationAmount}
            onChange={(e) => handleChange("monthlyDurationAmount", e.target.value)}
            error={errors.monthlyDurationAmount}
          />

          <DatePicker
            label="Monthly Start Date"
            name="monthlyStartDate"
            value={formData.monthlyStartDate}
            onChange={(val) => handleChange("monthlyStartDate", val)}
            error={errors.monthlyStartDate}
          />
        </div>
      </div>
      </>)}

    {isInstallment && (
      <>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-3 px-3 py-1">
          <button
            type="button"
            role="switch"
            aria-checked={formData.startOnBookingStream === "yearly"}
            onClick={() => handleToggleStartOnBooking("yearly")}
            className={`relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
              formData.startOnBookingStream === "yearly" ? "bg-primary" : "bg-gray-300"
            }`}
          >
            <span
              className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                formData.startOnBookingStream === "yearly" ? "translate-x-4" : "translate-x-0"
              }`}
            />
          </button>
          <span
            className="text-xs sm:text-sm font-medium text-gray-700 cursor-pointer select-none"
            onClick={() => handleToggleStartOnBooking("yearly")}
          >
            Start 1st installment on booking / down payment date
          </span>
          {formData.startOnBookingStream === "yearly" && (
            <span className="text-xs bg-emerald-50 text-emerald-600 border border-emerald-200 font-semibold px-2 py-0.5 rounded-full">
              Active
            </span>
          )}
        </div>
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 px-3 ">
          <MultiSelect
            label="Yearly Installment Type"
            name="yearlyInstallment"
            value={formData.yearlyInstallment}
            onChange={(val) => handleChange("yearlyInstallment", val)}
            error={errors.yearlyInstallment}
            options={Installment_Options}
          />

          <MultiSelect
            label="Yearly Duration"
            name="yearlyInstallmentDuration"
            value={formData.yearlyInstallmentDuration}
            onChange={(val) => handleChange("yearlyInstallmentDuration", val)}
            error={errors.yearlyInstallmentDuration}
            options={Yearly_Durtion}
          />

          <Input
            label="Yearly Duration Amount"
            name="yearlyDurationAmount"
            type="text"
            value={formData.yearlyDurationAmount}
            onChange={(e) => handleChange("yearlyDurationAmount", e.target.value)}
            error={errors.yearlyDurationAmount}
          />

          <DatePicker
            label="Yearly Start Date"
            name="yearlyStartDate"
            value={formData.yearlyStartDate}
            onChange={(val) => handleChange("yearlyStartDate", val)}
            error={errors.yearlyStartDate}
          />
        </div>
      </div>
      </>)}

      {isInstallment && (
        <div className="flex flex-col gap-3">
          <h3 className="px-3 font-semibold">Monthly & Balloon Installments</h3>
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 px-3">
            <MultiSelect label="Monthly & Balloon Installments" name="monthlyBalloonInstallment" value={formData.monthlyBalloonInstallment} onChange={(val) => handleChange("monthlyBalloonInstallment", val)} error={errors.monthlyBalloonInstallment} options={Installment_Options} />
            <MultiSelect label="Monthly & Balloon Duration" name="monthlyBalloonInstallmentDuration" value={formData.monthlyBalloonInstallmentDuration} onChange={(val) => handleChange("monthlyBalloonInstallmentDuration", val)} error={errors.monthlyBalloonInstallmentDuration} options={Monthly_Balloon_Durtion} />
            <Input label="Monthly & Balloon Amount" name="monthlyBalloonDurationAmount" type="text" value={formData.monthlyBalloonDurationAmount} onChange={(e) => handleChange("monthlyBalloonDurationAmount", e.target.value)} error={errors.monthlyBalloonDurationAmount} />
            <DatePicker label="Monthly & Balloon Start Date" name="monthlyBalloonStartDate" value={formData.monthlyBalloonStartDate} onChange={(val) => handleChange("monthlyBalloonStartDate", val)} error={errors.monthlyBalloonStartDate} />
          </div>
        </div>
      )}

      {isInstallment && (
        <div className="flex flex-col gap-3">
          <h3 className="px-3 font-semibold">Quarterly Balloon Installments</h3>
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 px-3">
            <MultiSelect label="Quarterly Balloon Installments" name="quarterlyBalloonInstallment" value={formData.quarterlyBalloonInstallment} onChange={(val) => handleChange("quarterlyBalloonInstallment", val)} error={errors.quarterlyBalloonInstallment} options={Installment_Options} />
            <MultiSelect label="Quarterly Balloon Duration" name="quarterlyBalloonInstallmentDuration" value={formData.quarterlyBalloonInstallmentDuration} onChange={(val) => handleChange("quarterlyBalloonInstallmentDuration", val)} error={errors.quarterlyBalloonInstallmentDuration} options={Quarterly_Balloon_Durtion} />
            <Input label="Quarterly Balloon Amount" name="quarterlyBalloonDurationAmount" type="text" value={formData.quarterlyBalloonDurationAmount} onChange={(e) => handleChange("quarterlyBalloonDurationAmount", e.target.value)} error={errors.quarterlyBalloonDurationAmount} />
            <DatePicker label="Quarterly Balloon Start Date" name="quarterlyBalloonStartDate" value={formData.quarterlyBalloonStartDate} onChange={(val) => handleChange("quarterlyBalloonStartDate", val)} error={errors.quarterlyBalloonStartDate} />
          </div>
        </div>
      )}

      {/* SUBMIT BUTTON */}

         <div className="px-3 pb-4 w-full flex  justify-end">
                      <div className="flex flex-wrap items-center gap-2">
                        <button
                          type="button"
                          className="btn-secondary"

                        >
                          Cancel
                        </button>

                          <button
                          type="button"
                          className="btn-secondary"
                          onClick={() => navigate("/app/installments")}
                        >
                          Perview
                        </button>
                        {/* <button
            onClick={handleSubmit}
                          className="btn-primary py-2 sm:px-12 px-6 w-fit"
                          disabled={createLoading}
                        >                                       
                          {createLoading ? <PulseLoader size={12} color='white'  /> : "Purchase Plan"}
                        </button> */}
                      </div>
                    </div>
  
    </div>
  );
});

export default InventoryPurchaseForm;

